import { render, staticRenderFns } from "./NotificationSettingsItem.vue?vue&type=template&id=728ddd93&scoped=true&"
import script from "./NotificationSettingsItem.vue?vue&type=script&lang=js&"
export * from "./NotificationSettingsItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSettingsItem.vue?vue&type=style&index=0&id=728ddd93&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ddd93",
  null
  
)

export default component.exports